import { Component, OnInit } from '@angular/core';
import { STORAGE_WHOLESALE_REDIRECT } from '../constants';
import { AccountService } from '../account.service';
import { AccountDTO } from '../../../../shared/account-dto';

@Component({
  selector: 'pv-wholesale-login',
  templateUrl: './wholesale-login.component.html',
  styleUrls: ['./wholesale-login.component.scss']
})
export class WholesaleLoginComponent implements OnInit {
  redirect;
  account: AccountDTO = { } as AccountDTO

  constructor(private accountService: AccountService) { }

  ngOnInit() {
    if (localStorage.getItem(STORAGE_WHOLESALE_REDIRECT)) {
      this.redirect = localStorage.getItem(STORAGE_WHOLESALE_REDIRECT).split('/')
    }
    // Subscribe to account
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)
  }

}
